import {AfterViewInit, Component, ElementRef, Input, ViewChild,
  CUSTOM_ELEMENTS_SCHEMA} from '@angular/core';
import {MultiCurrencyErrorInfo} from '@app/model/multi-currency-cart-error-info.model';
import {RoutingService, TranslatePipe} from '@spartacus/core';

@Component({
  selector: 'dcp-multi-currency-cart-error',
  templateUrl: './multi-currency-cart-error.component.html',
  styleUrls: ['./multi-currency-cart-error.component.scss'],
  imports: [TranslatePipe],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class MultiCurrencyCartErrorComponent implements AfterViewInit {
  @Input() errorInfo: MultiCurrencyErrorInfo;
  @Input() errorMsgMainText: string;
  @Input() errorMsgTheadText: string;
  @ViewChild('viewCartButton', {static: false}) viewCartButton: ElementRef;

  constructor(private routingService: RoutingService) {}

  ngAfterViewInit(): void {
    this.viewCartButton.nativeElement.focus();
  }

  redirectToCart(): void {
    this.routingService.go({
      cxRoute: 'cart',
    });
  }
}
